/* global __SERVER__ */

import React, { Component } from 'react';
import { func, string, array, bool } from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import styles from './TutorSignup.scss';
import MainLayout from '@dragonfruit/layouts/MainLayout';
import SinglePageLayout from '@dragonfruit/layouts/SinglePageLayout';
import Link from '@dragonfruit/components/Link';
import TutorSignupForm from '@dragonfruit/components/TutorSignupForm';
import { fetchRegions, getRegionsForTutor } from '@dragonfruit/redux/regions';
import SEOHead from '@dragonfruit/components/SEOHead';
import { signup, switchSignupRole } from '@dragonfruit/redux/signup';
import { fetchIpRegionInfoFlow } from '@dragonfruit/sagas/ipRegion';
import { getEnableWaitingList } from '@dragonfruit/redux/locale';
import {
  getAlertBannerStatus,
  showAlertBanner,
  hideAlertBanner,
} from '@dragonfruit/redux/alertBanner';
import { ALERT_SYSTEMINFO_THEME } from '@dragonfruit/constants/alertBannerThemes';
import { thailandTutorPageURL } from '@dragonfruit/constants/externalLinks';
import { TUTOR } from '@dragonfruit/constants/userRoles';
import {
  EN_TH,
  TH_TH,
} from '@snapask/common-components/dist/constants/locales';
import config from '@dragonfruit/config';
const { TUTOR_ONBOARDING_TH_REDIRECT } = config;

const mapStateToProps = state => ({
  alertBannerVisible: getAlertBannerStatus(state),
  regionList: getRegionsForTutor(state),
  ipRegionEnableWaitingList: getEnableWaitingList(state),
});

class TutorSignup extends Component {
  static prefetch = () => [fetchIpRegionInfoFlow];

  static propTypes = {
    alertBannerVisible: bool.isRequired,
    authType: string.isRequired,
    fetchRegions: func.isRequired,
    hideAlertBanner: func.isRequired,
    ipRegionEnableWaitingList: bool.isRequired,
    regionList: array.isRequired,
    showAlertBanner: func.isRequired,
    signup: func.isRequired,
    switchSignupRole: func.isRequired,
    t: func.isRequired,
  };

  static contextTypes = {
    urlLocale: string,
  };

  constructor(props, context) {
    super(props);

    const { urlLocale } = context;

    if (__SERVER__) return;

    // So far this is a work-around, we expect having a revamp for tutor-signup flow in Q3.
    if (
      TUTOR_ONBOARDING_TH_REDIRECT === 'true' &&
      (urlLocale === EN_TH || urlLocale === TH_TH)
    ) {
      window.open(thailandTutorPageURL, '_self');
    }
  }

  // @TODO should move to server side preloader
  componentDidMount = () => {
    const {
      fetchRegions,
      switchSignupRole,
      ipRegionEnableWaitingList,
    } = this.props;

    const forTutorRegistration = true;

    fetchRegions(forTutorRegistration);
    switchSignupRole(TUTOR);

    if (ipRegionEnableWaitingList) this.handleShowAlertBanner();
  };

  onSubmit = submitData => {
    const { email, password, region } = submitData;

    const signupData = {
      email,
      password,
      region,
    };

    const { signup } = this.props;

    signup(signupData);
  };

  onSelectCountry = country => {
    const { enableWaitingList } = country;

    const { alertBannerVisible, hideAlertBanner } = this.props;

    if (enableWaitingList && !alertBannerVisible) {
      this.handleShowAlertBanner();
    } else if (!enableWaitingList && alertBannerVisible) {
      hideAlertBanner();
    }
  };

  handleShowAlertBanner = () => {
    const { showAlertBanner, t } = this.props;

    showAlertBanner({
      message: t('tutorSignup.waitList.bannerText'),
      theme: ALERT_SYSTEMINFO_THEME,
      keepAlive: true,
    });
  };

  render() {
    const { t, regionList } = this.props;

    const { urlLocale } = this.context;

    const seoComponent = (
      <SEOHead
        path="signup-tutor"
        title={t('seo:seo.tutorSignup.title')}
        description={t('seo:seo.tutorSignup.description')}
      />
    );

    if (__SERVER__) {
      return seoComponent;
    }

    return (
      <MainLayout>
        {seoComponent}

        <SinglePageLayout
          bottom={
            <Link to={`/${urlLocale}/login`}>
              {t('tutorSignup.hasAccount')}
            </Link>
          }
        >
          <div className={styles.root}>
            <h3>{t('tutorSignup.title')}</h3>

            <p className={styles.registerWithEmail}>
              {t('tutorSignup.signupWithEmail')}
            </p>

            <TutorSignupForm
              regionList={regionList}
              onSubmit={this.onSubmit}
              onSelectCountry={this.onSelectCountry}
            />
          </div>
        </SinglePageLayout>
      </MainLayout>
    );
  }
}

TutorSignup.contextTypes = {
  urlLocale: string,
};

export default translate(['tutorSignup', 'seo'])(
  connect(mapStateToProps, {
    fetchRegions,
    signup,
    switchSignupRole,
    showAlertBanner,
    hideAlertBanner,
  })(TutorSignup)
);



// WEBPACK FOOTER //
// ./app/containers/TutorSignup/TutorSignup.jsx